import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DesignIcon } from '@monorepo/nova-icons';
import { Stack } from '@monorepo/nova-ui';
import { OptionalAssets } from '@monorepo/types';
import { formatAmount } from '../../balance/balance-utils';
import { type CreditCartAsset } from '../credit-events.types';
import {
  StyledAssetCard,
  StyledAssetCardLabel,
  StyledAssetCardRow,
  StyledAssetCardRowLabel,
  StyledAssetCardRowValue,
} from '../styled';

export const formatCreditAssetBuyingPower = (
  bp?: number,
): string | undefined => {
  if (!bp) return undefined;
  return bp >= 1000 ? `${Math.round(bp / 1000)}k funding` : `${bp} funding`;
};

interface CreditAssetCardsProps {
  cartAssets: CreditCartAsset[];
  selected: OptionalAssets;
  onSelect: (asset: OptionalAssets) => void;
}

export const CreditAssetCards: FC<CreditAssetCardsProps> = ({
  cartAssets,
  selected,
  onSelect,
}) => {
  const { t } = useTranslation(['creditEventsModal']);

  return (
    <>
      {cartAssets.map((item) => (
        <StyledAssetCard
          key={item.asset}
          selected={selected === item.asset}
          onClick={() => onSelect(item.asset)}
        >
          <Stack direction="row" alignItems="center" gap={1}>
            <DesignIcon
              iconName="The5ersLogoShort"
              useMuiSvgIcon={false}
              width={34}
              height={30}
            />
            <StyledAssetCardLabel>{item.assetLabel}</StyledAssetCardLabel>
          </Stack>

          <Stack width="100%" gap={0.5}>
            {item.groupName && (
              <StyledAssetCardRow>
                <StyledAssetCardRowLabel>
                  {item.groupName}
                </StyledAssetCardRowLabel>
                <StyledAssetCardRowValue>
                  {formatAmount(item.totalPrice)}
                </StyledAssetCardRowValue>
              </StyledAssetCardRow>
            )}

            {item.buyingPower && (
              <StyledAssetCardRow>
                <StyledAssetCardRowLabel>
                  {formatCreditAssetBuyingPower(item.buyingPower)}
                </StyledAssetCardRowLabel>
              </StyledAssetCardRow>
            )}

            <StyledAssetCardRow>
              <StyledAssetCardRowLabel>
                {t('creditEventsModal:selector.method')}
              </StyledAssetCardRowLabel>
              <StyledAssetCardRowValue>
                {item.tradingSystemLabel}
              </StyledAssetCardRowValue>
            </StyledAssetCardRow>
          </Stack>
        </StyledAssetCard>
      ))}
    </>
  );
};
